import {Anchor, Badge, Button, Divider, Grid, Group, Stack, Text, useMantineTheme} from '@mantine/core';
import {Check, CurrencyDollar, DeviceDesktop} from "tabler-icons-react";
import {EHomeSellingOptionActions, IHomeSellingOptionSubmitValues} from "features/homes"



interface Props {
    onSubmitQuery?: (values: IHomeSellingOptionSubmitValues) => void,
}

export function HomeSellingOptionsForm({onSubmitQuery}: Props) {
    const theme = useMantineTheme()
    async function onSubmit(values: IHomeSellingOptionSubmitValues) {
        if (onSubmitQuery) {
            await onSubmitQuery(values)
        }
    }


    return (
        <Stack spacing={24}>
            <Grid>
                <Grid.Col lg={6}>
                    <Stack spacing={12} bg={theme.colors.indigo[0]} p={18} sx={{
                        border: `1px solid ${theme.colors.indigo[2]}`,
                        borderRadius: 6
                    }}>
                        <Group position="center">
                            <Text size="xl" weight={600}>Simple Sale</Text>
                            <Badge color="green" variant="filled">Maximize Profit</Badge>
                        </Group>
                        <Group position="center">
                            <Group bg={theme.colors.indigo[1]} p={16} sx={{borderRadius: "50%"}}>
                                <DeviceDesktop size={36} color={theme.colors.indigo[7]}/>
                            </Group>
                        </Group>
                        <Group position="center" mb={9}>
                            <Text size="xs" color="dimmed">Tech-empowered listing with licensed agent support</Text>
                        </Group>
                        <Stack spacing={3} align="center" bg={theme.white} p={16} sx={{
                            border: `1px solid ${theme.colors.indigo[2]}`,
                            borderRadius: 6
                        }}>
                            <Group spacing={6} align="flex-end">
                                <Text size={24} weight={600} color={theme.colors.indigo[7]}
                                      sx={{lineHeight: "1em"}}>$5,000</Text>
                                <Text size="xs" color='dimmed'>flat fee</Text>
                            </Group>
                            <Text color='dimmed' size="xs" sx={{textAlign: "center"}}>vs. 5-6% commission (save $15,000+
                                on
                                average)</Text>
                        </Stack>
                        <Stack spacing={12} mt={12}>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>Online Platform Guidance</Text>
                                    <Text size="xs" color="dimmed">Breeze through each milestone with our tech
                                        platform</Text>
                                </Stack>
                            </Group>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>Licensed Agent Support</Text>
                                    <Text size="xs" color="dimmed">Direct guidance & negotiating power every step</Text>
                                </Stack>
                            </Group>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>No Quality Trade-offs</Text>
                                    <Text size="xs" color="dimmed">Cheaper process, same professional expertise</Text>
                                </Stack>
                            </Group>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>Maximum Market Value</Text>
                                    <Text size="xs" color="dimmed">Full MLS listing with professional marketing</Text>
                                </Stack>
                            </Group>
                        </Stack>
                        <Button mt={12} size="md" onClick={() => onSubmit({action: EHomeSellingOptionActions.SimpleSale})}>Start Simple Sale - $5,000</Button>
                    </Stack>
                </Grid.Col>
                <Grid.Col lg={6}>
                    <Stack h="100%" spacing={12} bg={theme.colors.orange[0]} p={18} sx={{
                        border: `1px solid ${theme.colors.orange[2]}`,
                        borderRadius: 6
                    }}>
                        <Group position="center">
                            <Text size="xl" weight={600}>Cash Offer</Text>
                            <Badge color="orange" variant="filled">Fast</Badge>
                        </Group>
                        <Group position="center">
                            <Group bg={theme.colors.orange[1]} p={16} sx={{borderRadius: "50%"}}>
                                <CurrencyDollar size={36} color={theme.colors.orange[7]}/>
                            </Group>
                        </Group>
                        <Group position="center" mb={9}>
                            <Text size="xs" color="dimmed">Multiple cash offers from our buyer network</Text>
                        </Group>
                        <Stack spacing={3} align="center" bg={theme.white} p={16} sx={{
                            border: `1px solid ${theme.colors.orange[2]}`,
                            borderRadius: 6
                        }}>
                            <Group spacing={6} align="flex-end">
                                <Text size={24} weight={600} color={theme.colors.orange[7]}
                                      sx={{lineHeight: "1em"}}>3%</Text>
                                <Text size="xs" color='dimmed'>commission</Text>
                            </Group>
                            <Text color='dimmed' size="xs">Competitive cash offer with lower fees</Text>
                        </Stack>
                        <Stack spacing={12} mt={12}>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>Multiple Cash Offers</Text>
                                    <Text size="xs" color="dimmed">Leverage our buyer network within 5 days</Text>
                                </Stack>
                            </Group>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>Instant Option Available</Text>
                                    <Text size="xs" color="dimmed">Get immediate offer within 24 hours</Text>
                                </Stack>
                            </Group>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>Close in as Soon as 14 Days</Text>
                                    <Text size="xs" color="dimmed">Lightning-fast closing process</Text>
                                </Stack>
                            </Group>
                            <Group spacing={9} noWrap align="flex-start">
                                <Check size={22} color={theme.colors.green[7]}/>
                                <Stack spacing={0}>
                                    <Text size="xs" weight={600}>No Repairs Needed</Text>
                                    <Text size="xs" color="dimmed">Sell your home as-is, any condition</Text>
                                </Stack>
                            </Group>
                        </Stack>
                        <Button color="orange" mt="auto" size="md" onClick={() => onSubmit({action: EHomeSellingOptionActions.CashOffer})}>Get Cash Offers - 3%</Button>
                    </Stack>
                </Grid.Col>
            </Grid>
            <Divider/>
            <Stack align="center" spacing={3}>
                <Text color="dimmed" size="xs">Not sure which option is right for you?</Text>
                <Anchor size="xs" onClick={() => onSubmit({action: EHomeSellingOptionActions.Consultation})}>Speak with a Behoused Expert - Free Consultation</Anchor>
            </Stack>
        </Stack>
    )
}
